import { KeyboardEvent } from 'react';

export function searchOnEnter(searchFn: () => unknown): (evt: KeyboardEvent) => void {
  return (event: KeyboardEvent) => {
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
      searchFn();
    }
  };
}
